
import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			currentValue: 0,
		};
	},

	props: {
		value: { type: Number, default: null },
		state: { type: Boolean, default: null },
		id: { type: String },
		disabled: { type: Boolean, default: false },
	},

	mounted() {
		this.currentValue = this.value;
	},

	computed: {
		minutes: {
			get(): number {
				return Math.floor(this.currentValue / 60);
			},
			set(value: number) {
				value = Math.max(value, 0);
				this.currentValue = value * 60 + this.seconds;
				this.$emit('input', this.currentValue);
			},
		},
		seconds: {
			get(): number {
				return this.currentValue % 60;
			},
			set(value: number) {
				value = Math.max(Math.min(value, 60), 0);
				this.currentValue = this.minutes * 60 + value;
				this.$emit('input', this.currentValue);
			},
		},
	},
});
